/* eslint-disable unicorn/prefer-code-point */
/* eslint-disable unicorn/prefer-prototype-methods */
import APIV5 from '~/models/api';
import moment from 'moment';
import dayjs from 'dayjs';
import { BroadcastChannel } from 'broadcast-channel';
// eslint-disable-next-line import/no-cycle
import { ResetModel } from '~/scripts/services/model/reset';

/* globals Knitiv */

// eslint-disable-next-line import/prefer-default-export
export class UserModel {
	/** @type {number} */
	#lastGetReferenceMillis = 0;

	/** @type {number} */
	#lastGetReferenceSeconds = 0;

	/** @type {string | undefined} */
	#lastGetReferenceValue;

	/** @type {Object<string, string>} */
	#locale;

	#profilId;

	#referenceSr;

	/** @type {ResetModel} */
	#Reset;

	/** @type {any} */
	#sessionTimeout;

	#settings;

	/**
	 * @ngdoc service
	 * @name app.factory:User
	 * @description user
	 * Factory in the app.
	 * @param {import('angular').IFilterService} $filter
	 * @param {import('angular').ILocationService} $location
	 * @param {import('angular').ui.bootstrap.IModalStackService} $uibModalStack
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {*} Notification
	 * @param {ResetModel} Reset
	 */
	/* @ngInject */
	constructor(
		$filter,
		$location,
		$uibModalStack,
		$rootScope,
		$timeout,
		$translate,
		Notification,
		Reset,
	) {
		this.#lastGetReferenceSeconds = -1;
		this.#locale = {
			fr: 'K_NODE;FRANCAIS',
			en: 'K_NODE;ANGLAIS',
		};
		this.#profilId = '000000';
		this.#referenceSr = 0;
		// @ts-ignore
		$rootScope.context = {};

		this.$filter = $filter;
		this.$location = $location;
		this.$rootScope = $rootScope;
		this.$timeout = $timeout;
		this.$translate = $translate;
		this.$uibModalStack = $uibModalStack;
		this.Notification = Notification;
		this.#Reset = Reset;

		try {
			this.#settings = JSON.parse(localStorage.getItem('user') || '') || {};
		}
		catch {
			this.#settings = {};
		}
	}

	startListeners() {
		this.channel = new BroadcastChannel('sessionTimeout');
		this.removeStorageListener = window.addEventListener('storage', this.handleStorage.bind(this));

		this.channel.addEventListener('message', this.resetSessionTimer.bind(this));
	}

	removeListeners() {
		// eslint-disable-next-line unicorn/no-invalid-remove-event-listener
		window.removeEventListener('storage', this.handleStorage.bind(this));
		// eslint-disable-next-line unicorn/no-invalid-remove-event-listener
		this.channel?.removeEventListener('message', this.resetSessionTimer.bind(this));
		this.channel?.close();
	}

	/**
	 * @param {any} event
	 */
	handleStorage(event) {
		if (event.key === 'token' && event.newValue === null && event.oldValue !== null) {
			this.logout('LOGOUT_USER_FROM_ANOTHER_TAB');
		}
	}

	async fetchBackConfig() {
		this.$rootScope.appConfig = await APIV5.instance.getConfig({
			client: {
				url: this.$location.url(),
			},
		}, { id: 'user-model.get-back-config' });
	}

	/**
	 * @returns {import('@knitiv/api-client-javascript').GetConfigOutput['config']}
	 */
	getAppConfig() {
		return this.$rootScope.appConfig?.config ?? null;
	}

	/**
	 * Get context of the user
	 * TODO: language management
	 *
	 * @returns {any}
	 */
	getContext() {
		const getLocaleKid = () => {
			const use = this.$translate.use();
			if (use in this.#locale) {
				return this.#locale[use];
			}
			return this.#locale.fr;
		};
		return { lang: [getLocaleKid()] };
	}

	/**
	 * Get the profile of the current user
	 *
	 * @memberOf UserReturn
	 * @returns {UserProfile}
	 */
	getProfil() {
		// @ts-ignore
		return this.$rootScope.context.profil;
	}

	/**
	 * Get a new identifier for K_NODE;xxx
	 *
	 * @returns {string}
	 */
	getRef() {
		let currentTime; let years; let months; let days; let hours; let minutes; let seconds; let milliseconds;
		let referenceChiffre; let nbSec; let nbMilli;
		let index; let referenceZip; let codeA; let temporary; let modulo;
		let entiere = 0;

		while (this.#profilId.length < 6) {
			this.#profilId = `0${this.#profilId}`;
		}

		this.#profilId = this.#profilId.slice(0, 6);

		do {
			currentTime = new Date();
			years = currentTime.getFullYear();
			months = currentTime.getMonth() + 1;
			days = currentTime.getDate();
			hours = currentTime.getHours();
			minutes = currentTime.getMinutes();
			seconds = currentTime.getSeconds();
			milliseconds = currentTime.getTime();

			//---
			if (this.#lastGetReferenceSeconds === -1) {
				this.#lastGetReferenceSeconds = seconds;
				this.#lastGetReferenceMillis = milliseconds;
			}
			//---
			if (seconds <= this.#lastGetReferenceSeconds) {
				if (seconds === this.#lastGetReferenceSeconds) {
					if (milliseconds <= this.#lastGetReferenceMillis) {
						milliseconds = this.#lastGetReferenceMillis + 1;
					}
				}
				else {
					seconds = this.#lastGetReferenceSeconds;
					milliseconds = this.#lastGetReferenceMillis + 1;
				}

				if (milliseconds >= 1000) {
					milliseconds = 0;
					seconds++;

					if (seconds >= 86_400) {
						seconds = 0;
						hours++;
					}
				}
			}

			this.#lastGetReferenceSeconds = seconds;
			this.#lastGetReferenceMillis = milliseconds;

			referenceChiffre = years;
			if (months < 10) {
				// @ts-ignore
				referenceChiffre += '0';
			}

			referenceChiffre += months;
			if (days < 10) {
				// @ts-ignore
				referenceChiffre += '0';
			}

			referenceChiffre += days;
			nbSec = `${hours * 3600 + minutes * 60 + seconds}`;

			while (nbSec.length < 5) {
				nbSec = `0${nbSec}`;
			}
			nbMilli = `${milliseconds % 1000}`;

			while (nbMilli.length < 5) {
				nbMilli = `0${nbMilli}`;
			}

			// @ts-ignore
			referenceChiffre += nbSec + nbMilli;

			// COMPRESS
			index = 1;
			referenceZip = '';
			codeA = 'A'.charCodeAt(0);
			// @ts-ignore
			while (index < referenceChiffre.length) {
				// @ts-ignore
				temporary = referenceChiffre.slice(index - 1, index + 2);
				modulo = (temporary % 36);
				entiere = (temporary - modulo) / 36;

				if (modulo > 9) {
					modulo = String.fromCharCode(modulo - 10 + codeA);
				}
				if (entiere > 9) {
					// @ts-ignore
					entiere = String.fromCharCode(entiere - 10 + codeA);
				}
				referenceZip = referenceZip + entiere + modulo;
				index += 3;
			}
			// FINAL STRING FORMAT
			referenceChiffre = this.#profilId + referenceZip;
		}
		while (referenceChiffre === this.#lastGetReferenceValue);

		this.#lastGetReferenceValue = referenceChiffre;

		return referenceChiffre;
	}

	/**
	 * Get a new _NR_ identifier for K_NODE;xxx
	 *
	 * @returns {string}
	 */
	getRefNr() {
		this.#referenceSr++;
		return `_NR_${this.$filter('sprintf')('%06d', this.#referenceSr)}`;
	}

	/**
	 * @returns {import('@knitiv/api-client-javascript').AuthenticationObject}
	 */
	getSession() {
		// @ts-ignore
		return this.$rootScope.context;
	}

	/**
	 * @param {string} key
	 * @returns {any}
	 */
	getSetting(key) {
		return this.$rootScope.context ? this.#settings[this.$rootScope.context.profil.kid][key] : null;
	}

	logged() {
		// @ts-ignore
		return this.$rootScope?.context?.token;
	}

	/**
	 * Logout the current user and destroy his session
	 *
	 * @param {string} reason
	 */
	logout(reason) {
		const unit = this.$rootScope.context?.token?.expiration_delay_unit;
		const duration = moment.duration(
			this.$rootScope.context?.token?.expiration_delay,
			// @ts-ignore
			unit === 0 ? 'minute' : unit,
		);

		this.$uibModalStack.dismissAll();

		if (this.logged()) {
			let allowRedirect = true;
			let redirectURL = `/login?logout&error=${reason}`;

			this.$timeout(() => {
				let cleanup = true;
				switch (reason) {
				case 'SESSION_TIMED_OUT': {
					// eslint-disable-next-line promise/catch-or-return
					this.Notification.warning({
						title: this.$translate.instant('user.session-timeout-title'),
						message: this.$filter('sprintf')(this.$translate.instant('user.session-timeout-reason'),
							duration.humanize()),
						delay: Object.create(null),
						replaceMessage: true,
					}).then((/** @type {any} */ s) => {
						// @ts-ignore
						this.$rootScope.scopeNotification = s;
						return true;
					});
					break;
				}

				case 'SESSION_TIMEOUT': {
					this.Notification.warning({
						title: this.$translate.instant('user.session-timeout-title'),
						message: this.$filter('sprintf')(this.$translate.instant('user.session-timeout-reason'),
							duration.humanize()),
						replaceMessage: true,
					});
					break;
				}

				case 'NO_TOKEN': {
					this.Notification.warning({
						title: this.$translate.instant('user.session-error'),
						message: this.$translate.instant('user.session-no-token'),
						replaceMessage: true,
					});
					break;
				}

				case 'LOGOUT_USER_FROM_ANOTHER_TAB': {
					this.Notification.info({
						title: this.$translate.instant('common.info'),
						message: this.$translate.instant('user.session-logout-from-another-tab'),
						replaceMessage: true,
					});
					break;
				}

				case 'LOGOUT_USER': {
					this.Notification.info({
						title: this.$translate.instant('common.info'),
						message: this.$translate.instant('user.session-logout'),
						replaceMessage: true,
					});
					allowRedirect = false;
					break;
				}

				case 'PASSWORD_MUST_CHANGE': {
					cleanup = false;
					redirectURL = '/passchange';
					allowRedirect = false;
					break;
				}

				default: {
					break;
				}
				}

				// Cleanup
				if (cleanup) {
					this.#Reset.resetApp();
					this.$rootScope.$broadcast('User.logout');
				}

				if (allowRedirect) {
					const redirectTo = this.$location.url() === '/'
						? ''
						: `redirectTo=${this.$location.url()}`;
					redirectURL += `&${redirectTo}`;
				}
				this.$location.url(redirectURL);
			}, 150);
		}
	}

	saveSettings() {
		localStorage.setItem('user', JSON.stringify(this.#settings));
	}

	saveToken() {
		if (this.$rootScope.context?.token.id) {
			localStorage.setItem('token', this.$rootScope.context?.token.id);
		}
		else {
			localStorage.removeItem('token');
		}
	}

	/**
	 * Set user informations
	 *
	 * @param {import('@knitiv/api-client-javascript').AuthenticationObject | undefined} context
	 * @returns {this}
	 */
	set(context) {
		// @ts-ignore
		this.$rootScope.context = context;
		if (context && this.$rootScope) {
			this.$rootScope.kds = context.version >= '5';
		}
		if (context && !this.$rootScope.context?.lang.id) {
			// @ts-ignore
			this.$rootScope.context.lang.id = Object.keys(this.#locale).find(key => this.#locale[key] === context.lang.kid);
		}
		if (context && !(context.profil.kid in this.#settings)) {
			this.#settings[context.profil.kid] = {};
		}
		if (context?.passchange === 1) {
			this.$rootScope.userPassChange = true;
			this.$location.path('/passchange');
		}
		return this;
	}

	/**
	 * Set user alive
	 *
	 * @param {any} token
	 */
	setAlive(token) {
		// eslint-disable-next-line unicorn/require-post-message-target-origin
		this.channel?.postMessage(token);
		this.resetSessionTimer(token);
	}

	/**
	 * @param {string} key
	 * @param {any} value
	 */
	setSetting(key, value) {
		if (this.$rootScope.context) {
			this.#settings[this.$rootScope.context.profil.kid][key] = value;
		}
		else {
			this.#settings = {};
		}
		this.saveSettings();
	}

	/**
	 * Reset current user session timer
	 *
	 * @param {any} token
	 */
	resetSessionTimer(token) {
		const time = dayjs(dayjs()).diff(token.expiration);

		// Cancel current timer
		this.$timeout.cancel(this.#sessionTimeout);

		this.#sessionTimeout = this.$timeout(() => {
			this.$rootScope.$broadcast('API.logout', 'SESSION_TIMED_OUT');
		}, Math.abs(time));
		// @ts-ignore
		this.$rootScope.context.token = token;
	}

	/**
	 * Set language
	 *
	 * @param {{ code: string, kid: string }} lang
	 * @returns {this}
	 */
	setLang(lang) {
		// @ts-ignore
		this.$rootScope.appConfig.lang = lang;
		return this;
	}
}
